import { FC } from 'react';
import { ProductGridStoryblok } from 'storyblok-types';
import { IStoryBlokComponentProps } from 'pages/StoryBlok/types';
import { View1 } from './View1';
import { View2 } from './View2';

export const ProductGrid: FC<IStoryBlokComponentProps<ProductGridStoryblok>> = (
  props,
) => {
  const { categorySlug } = props.blok;

  return categorySlug ? <View2 {...props} /> : <View1 {...props} />;
};
